import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App.jsx';

import './styles/main.css';
import './styles/layout.css';
import './styles/components.css';

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
